<template lang="html">
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass">
  .container
    padding-top: 3.5rem

</style>



// WEBPACK FOOTER //
// Container.vue?55779f3e